import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type Props = {
  id: string | null | undefined;
};

export const useSelectAllList = ({ id }: Props) => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: ["select-all-list", id],
    queryFn: () => apiClient.selectLists.select({ requestBody: { list_id: id! } }),
    enabled: !!id,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
};
